import React from 'react';
import { Checkbox } from '@cambridgeassessment/cambridge-ui';
import { StyledFileTypes, StyledFileTypeContainer, StyledFileNameContainer, StyledFileTypeNameSubtext } from './styles';
import { FileType } from './fileTypes';
import { StyledReadOnlyComponent } from '../styles';
import { Roles } from '@cambridgeassessment/lib-ee-commons';
import { Authorized } from 'lib-browser';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store';

interface Props {
  fileType: FileType;
  disabled?: boolean;
  checked?: boolean;
  isTheLastChecked: boolean;
  onChange: (name: string, value: boolean) => void;
  showSnackbar: (isTheLastChecked: boolean) => void;
  dataQaId: string;
  subtext?: string;
}

const Component = ({
  fileType,
  checked,
  disabled,
  onChange,
  isTheLastChecked,
  showSnackbar,
  dataQaId,
  subtext,
}: Props): React.ReactElement => {
  const selectedRole = useSelector((state: RootState) => state.userData.selectedRole);

  const updateFileType = (value: boolean): void => {
    onChange(fileType.name, value);
  };

  const onClick = (): void => showSnackbar(isTheLastChecked);

  const formattedFiles = fileType.formats.map((str: string): string => str.substring(1)).join(' ');

  return (
    <Authorized
      selectedRole={selectedRole}
      roles={[Roles.SUBMIT_SUPER_ADMIN]}
      readOnlyRoles={[Roles.SUBMIT_COMPLIANCE, Roles.SUBMIT_INTERNAL_ASSESSMENT_MANAGER, Roles.SUBMIT_ADMINISTRATOR]}
    >
      <StyledReadOnlyComponent>
        <StyledFileTypeContainer>
          <div onClick={onClick}>
            <Checkbox
              dataQaId={`${dataQaId}-checkbox-${fileType.name}`}
              checked={checked}
              onChange={updateFileType}
              disabled={disabled}
              ariaLabel={fileType.name}
            />
          </div>
          <StyledFileNameContainer>
            <div>
              {fileType.name}
              {subtext ? <StyledFileTypeNameSubtext>(Not supported by RMA3)</StyledFileTypeNameSubtext> : null}
            </div>
            <StyledFileTypes>{formattedFiles}</StyledFileTypes>
          </StyledFileNameContainer>
        </StyledFileTypeContainer>
      </StyledReadOnlyComponent>
    </Authorized>
  );
};

export default Component;
